import { createSlice } from "@reduxjs/toolkit";
import HastaRaporListesiRequests from "src/models/HastaRaporSonuclari/HastaRaporListesiRequests";
import HastaRaporSonuclariHastaListesiDTO from "src/models/HastaRaporSonuclari/HastaRaporSonuclariHastaListesiDTO";
import VwHastarapordetayDTO from "src/models/PatolojiModul/VwHastarapordetayDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { ApiResponse } from "src/services/core";
interface IState {
    searchHandler: boolean;
    aramaKriterleri: HastaRaporListesiRequests;
    data?: ApiResponse<Array<HastaRaporSonuclariHastaListesiDTO>>;
    activeRow: HastaRaporSonuclariHastaListesiDTO;
    hastaRaporDetayActiveRow: VwHastarapordetayDTO;
    editMode: boolean;
};

export const HastaRaporSonuclariSlice = createSlice<IState, MapReducerPayloads<IState, {
    setSearchHandler: boolean;
    setAramaKriterleri: HastaRaporListesiRequests;
    setData?: ApiResponse<Array<HastaRaporSonuclariHastaListesiDTO>>;
    setActiveRow: HastaRaporSonuclariHastaListesiDTO;
    setHastaRaporDetayActiveRow: VwHastarapordetayDTO;
    setEditMode: boolean;
}>>({
    name: "hastaRaporSonuclari",
    initialState: {
        searchHandler: true,
        aramaKriterleri: new HastaRaporListesiRequests(),
        activeRow: new HastaRaporSonuclariHastaListesiDTO(),
        hastaRaporDetayActiveRow: new VwHastarapordetayDTO(),
        editMode: false,
    },
    reducers: {
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload
        },
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        setHastaRaporDetayActiveRow: (state, action) => {
            state.hastaRaporDetayActiveRow = action.payload
        },
        setEditMode: (state, action) => {
            state.editMode = action.payload
        },
        setData: (state, action) => {
            state.data = action.payload
        },
    }
});